import { render } from "./AgentsListing.vue?vue&type=template&id=130ac27e&scoped=true"
import script from "./AgentsListing.vue?vue&type=script&lang=js"
export * from "./AgentsListing.vue?vue&type=script&lang=js"

import "./AgentsListing.vue?vue&type=style&index=0&id=130ac27e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130ac27e"]])

export default __exports__